import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { ReviewRequestItem } from '@/domain/entities/reviewRequest/reviewRequestItem'
import { JudgeStatusType } from '@/domain/value_objects/judge/JudgeStatusType'
import { DisplayLanguageType } from '@/domain/value_objects/language/displayLanguageType'
import { ReviewRequestModuleName } from '@/store/modules/modules'

export class ReviewRequestViewModel {
  private store = useStore()

  reviewRequestList: ComputedRef<ReviewRequestItem[]> = computed(
    () => this.store.getters[`${ReviewRequestModuleName}/reviewRequestList`]
  )
  freeDescription: ComputedRef<string> = computed(
    () => this.store.getters[`${ReviewRequestModuleName}/freeDescription`]
  )
  reviewJudgeId: ComputedRef<string> = computed(() => this.store.getters[`${ReviewRequestModuleName}/reviewJudgeId`])
  reviewJudgeStatus: ComputedRef<JudgeStatusType> = computed(
    () => this.store.getters[`${ReviewRequestModuleName}/reviewJudgeStatus`]
  )
  isLoading: ComputedRef<boolean> = computed(() => this.store.getters[`${ReviewRequestModuleName}/isLoading`])
  error: ComputedRef<Error | null> = computed(() => this.store.getters[`${ReviewRequestModuleName}/error`])

  setFreeDescription(message: string): void {
    this.store.commit(`${ReviewRequestModuleName}/setFreeDescription`, { message })
  }

  setReviewJudgeId(judgeId: string): void {
    this.store.commit(`${ReviewRequestModuleName}/setReviewJudgeId`, { judgeId })
  }

  setReviewJudgeStatus(status: JudgeStatusType): void {
    this.store.commit(`${ReviewRequestModuleName}/setReviewJudgeStatus`, { status })
  }

  async getReviewRequestList(status: string, displayLanguage: DisplayLanguageType): Promise<void> {
    await this.store.dispatch(`${ReviewRequestModuleName}/getReviewRequestList`, { status, displayLanguage })
  }

  async postRegisterEntry(
    judgeId: string,
    requests: string[],
    message: string,
    displayLanguage: DisplayLanguageType
  ): Promise<void> {
    await this.store.dispatch(`${ReviewRequestModuleName}/postRegisterEntry`, {
      judgeId,
      requests,
      message,
      displayLanguage
    })
  }
}
